import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import { CompanyTypes } from '../types/enums';

export type StatisticsItem = {
    statID: number,
    total: number,
    active: number,
    pending: number,
    pastDue: number,
    pendingStatus: number
}

export const useGetStatistics = (companyID: number, userName: string, companyType: CompanyTypes) => {

    let url = '';
    switch (companyType) {
        case CompanyTypes.CFI:
            url = 'statistics/cfi';
            break;
        case CompanyTypes.DEALER:
            url = 'statistics/dealer';
            break;
        case CompanyTypes.DISTRIBUTOR:
        case CompanyTypes.MFR:
        case CompanyTypes.SERVICE_PROVIDER:
            url = 'statistics/distributor';
            break;
    }

    const { data, isLoading, isFetching } = useQuery({
        queryKey: ['statistics', companyID, userName],
        queryFn: async () => await apiClient.get(url) as StatisticsItem[]
    });

    return {
        data: data || [],
        isLoading: isLoading,
        isFetching
    };
};
